import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";

export const getNotificationsUnreadCount = () => {
  return dispatch => {
    api
      .notificationsGetUnread()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetNotificationsErrorAlertTitle",
          "Virhe ilmoitusten lukumäärän haussa",
          e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "SET_UNREAD_NOTIFICATIONS_COUNT",
  payload: data,
});

const operationFail = () => ({
  type: "GET_UNREAD_NOTIFICATIONS_COUNT_FAIL"
});
